import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ALLOWED_ROLES = ['admin', 'schwimmadmin', 'trainer'];

export default function TrainerRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner" />
        <p>Laden…</p>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (!ALLOWED_ROLES.includes(user.rolle)) return <Navigate to="/" replace />;

  return children;
}
